import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const VINSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="vin-container">
      <svg
        width="20"
        height="18"
        viewBox="0 0 18 13"
        data-testid="vin-svg"
      >
        <path
          d="M2 0C0.896875 0 0 0.832813 0 1.85714V11.1429C0 12.1672 0.896875 13 2 13H16C17.1031 13 18 12.1672 18 11.1429V1.85714C18 0.832813 17.1031 0 16 0H2ZM3.75 2.78571C4.16563 2.78571 4.5 3.09621 4.5 3.48214V9.51786C4.5 9.90379 4.16563 10.2143 3.75 10.2143C3.33437 10.2143 3 9.90379 3 9.51786V3.48214C3 3.09621 3.33437 2.78571 3.75 2.78571ZM5.5 3.25C5.5 2.99464 5.725 2.78571 6 2.78571C6.275 2.78571 6.5 2.99464 6.5 3.25V9.75C6.5 10.0054 6.275 10.2143 6 10.2143C5.725 10.2143 5.5 10.0054 5.5 9.75V3.25ZM8.25 2.78571C8.66562 2.78571 9 3.09621 9 3.48214V9.51786C9 9.90379 8.66562 10.2143 8.25 10.2143C7.83437 10.2143 7.5 9.90379 7.5 9.51786V3.48214C7.5 3.09621 7.83437 2.78571 8.25 2.78571ZM11 3.48214C11 3.09621 11.3344 2.78571 11.75 2.78571C12.1656 2.78571 12.5 3.09621 12.5 3.48214V9.51786C12.5 9.90379 12.1656 10.2143 11.75 10.2143C11.3344 10.2143 11 9.90379 11 9.51786V3.48214ZM14.5 2.78571C14.775 2.78571 15 2.99464 15 3.25V9.75C15 10.0054 14.775 10.2143 14.5 10.2143C14.225 10.2143 14 10.0054 14 9.75V3.25C14 2.99464 14.225 2.78571 14.5 2.78571Z"
          fill="#070B16"
        />
      </svg>
    </StyledContainer>
  );
};

export default VINSVG;
